export const americanIsoCodes = [
  'us',
  'ca',
  'mx',
  'bz',
  'cr',
  'sv',
  'gt',
  'hn',
  'ni',
  'pa',
  'bs',
  'bb',
  'cu',
  'do',
  'ht',
  'jm',
  'tt',
  'pr',
  'ag',
  'dm',
  'gd',
  'kn',
  'lc',
  'vc',
  'sx',
  'bq',
  'aw',
  'cw',
  'tc',
  'vg',
  'vi',
  'ar',
  'bo',
  'br',
  'cl',
  'co',
  'ec',
  'gy',
  'py',
  'pe',
  'sr',
  'uy',
  've',
  'gf',
  'ai',
  'bl',
  'bm',
  'gp',
  'ky',
  'mq',
  'ms',
  'pm',
]

export const europeanIsoCodes = [
  'ad',
  'al',
  'at',
  'ax',
  'ba',
  'be',
  'bg',
  'by',
  'ch',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fo',
  'fr',
  'gb',
  'gg',
  'gi',
  'gr',
  'hr',
  'hu',
  'ie',
  'im',
  'is',
  'it',
  'je',
  'li',
  'lt',
  'lu',
  'lv',
  'mc',
  'md',
  'me',
  'mf',
  'mk',
  'mt',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'rs',
  'ru',
  'se',
  'si',
  'sj',
  'sk',
  'sm',
  'ua',
  'va',
  'xk',
  'es-ca',
  'es-ga',
  'es-sv',
  'gb-eng',
  'gb-nir',
  'gb-sct',
  'gb-wls',
  'cy',
  'gl',
]

export const asianIsoCodes = [
  'ae',
  'af',
  'am',
  'az',
  'bd',
  'bh',
  'bn',
  'bt',
  'cn',
  'ge',
  'hk',
  'id',
  'il',
  'in',
  'iq',
  'ir',
  'jo',
  'jp',
  'kg',
  'kh',
  'kp',
  'kr',
  'kw',
  'kz',
  'la',
  'lb',
  'lk',
  'mm',
  'mn',
  'mo',
  'mv',
  'my',
  'np',
  'om',
  'ph',
  'pk',
  'ps',
  'qa',
  'sa',
  'sg',
  'sy',
  'th',
  'tj',
  'tl',
  'tm',
  'tr',
  'tw',
  'uz',
  'vn',
  'ye',
]

export const africanIsoCodes = [
  'ao',
  'bf',
  'bi',
  'bj',
  'bw',
  'cd',
  'cf',
  'cg',
  'ci',
  'cm',
  'cv',
  'dj',
  'dz',
  'eg',
  'eh',
  'er',
  'et',
  'ga',
  'gh',
  'gm',
  'gn',
  'gq',
  'gw',
  'ke',
  'km',
  'lr',
  'ls',
  'ly',
  'ma',
  'mg',
  'ml',
  'mr',
  'mu',
  'mw',
  'mz',
  'na',
  'ne',
  'ng',
  're',
  'rw',
  'sc',
  'sd',
  'sh',
  'sl',
  'sn',
  'so',
  'ss',
  'st',
  'sz',
  'td',
  'tg',
  'tn',
  'tz',
  'ug',
  'yt',
  'za',
  'zm',
  'zw',
]

export const otherIsoCodes = [
  'aq',
  'as',
  'au',
  'ck',
  'fj',
  'fm',
  'gu',
  'ki',
  'mh',
  'mp',
  'nc',
  'nf',
  'nr',
  'nu',
  'nz',
  'pg',
  'pw',
  'sb',
  'tk',
  'to',
  'tv',
  'vu',
  'wf',
  'ws',
  'um',
  'bv',
  'cx',
  'hm',
  'tf',
  'gs',
  'pn',
  'un',
  'eu',
  'cc',
  'fk',
  'io',
  'pf',
]

export const isoCodes: string[] = [
  ...americanIsoCodes,
  ...europeanIsoCodes,
  ...asianIsoCodes,
  ...africanIsoCodes,
  ...otherIsoCodes,
]
